import React from 'react';
import Navbar from '../../components/Navbar';

const LEADERSHIP_TEAM = [
  {
    name: 'Laxmikant Timilsina',
    role: 'Owner – Vivah Nepal (Matrimonial Agency)',
    residence: 'Tansen-09, Palpa, Nepal',
    phone: '9857074103',
    domain: 'vivahnepal.com',
    bio: 'Founder and owner of Vivah Nepal Matrimonial Agency. Oversees client relationship management, traditional Kundali matching, and partner integration.',
    badge: 'Matrimony Owner',
    badgeColor: 'var(--rose-l)',
    badgeTextColor: 'var(--rose-d)',
    icon: '💍'
  },
  {
    name: 'Krishna Khanal',
    role: 'Owner – Sabitri Catering and Tent House',
    residence: 'Tansen-09, Palpa, Nepal',
    phone: '9867155395',
    domain: 'sabitricatering.com',
    bio: 'Founder and owner of Sabitri Catering and Tent House. Manages royal banquets, tent house equipment inventory, and catering operations.',
    badge: 'Catering & Decor Owner',
    badgeColor: 'var(--gold-l)',
    badgeTextColor: 'var(--gold-d)',
    icon: '🎪'
  },
  {
    name: 'Prakash Sharma Timilsina',
    role: 'Lead Technical Consultant & Digital Architect',
    residence: 'Kathmandu / Global Technical Architect',
    phone: 'Technical Advisory',
    domain: 'pourkas.org',
    websiteUrl: 'https://pourkas.org',
    bio: 'Architect and Technical Advisor leading the Python Django backend, React web applications, GCP multi-domain cloud hosting, and data security architecture.',
    badge: 'Technical Consultant',
    badgeColor: '#E8F5E9',
    badgeTextColor: '#2E7D32',
    icon: '💻'
  }
];

export default function Team() {
  return (
    <div className="pi">
      <Navbar module="catering" />

      <div className="sh">
        <span className="ey ey-s">✦ Business Partners & Technical Board ✦</span>
        <h1>Leadership & <em>Technical Advisory</em></h1>
        <p>
          Shared Head Office: <strong>Yogikuti Chowk, Butwal-10, Lumbini, Nepal</strong>. Operating strategic tie-up for <strong>Vivah Nepal</strong> (`vivahnepal.com`) and <strong>Sabitri Catering and Tent House</strong> (`sabitricatering.com`).
        </p>
      </div>

      <div className="sec" style={{ maxWidth: '1100px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
          gap: '2rem'
        }}>
          {LEADERSHIP_TEAM.map((t, idx) => (
            <div key={idx} className="card card-lg" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                  <div style={{ fontSize: '2.5rem' }}>{t.icon}</div>
                  <span className="tag" style={{ background: t.badgeColor, color: t.badgeTextColor, fontWeight: 700 }}>
                    {t.badge}
                  </span>
                </div>

                <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.7rem', fontWeight: 700, margin: '0.2rem 0', color: 'var(--deep)' }}>
                  {t.name}
                </h3>
                <div style={{ fontSize: '0.82rem', fontWeight: 700, color: 'var(--rose)', marginBottom: '0.5rem' }}>
                  {t.role}
                </div>
                <div style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--gold-d)', marginBottom: '0.8rem' }}>
                  📍 Residence / Base: {t.residence}
                </div>
                <p style={{ fontSize: '0.86rem', color: 'var(--mid)', lineHeight: 1.65, marginBottom: '1.2rem' }}>
                  {t.bio}
                </p>
              </div>

              <div style={{ borderTop: '1px solid var(--cream-d)', paddingTop: '0.8rem' }}>
                <div style={{ fontSize: '0.82rem', fontWeight: 700, color: 'var(--deep)' }}>
                  📞 Direct Contact: <a href={`tel:${t.phone.replace(/[^0-9]/g, '')}`} style={{ color: 'var(--rose)' }}>{t.phone}</a>
                </div>
                <div style={{ fontSize: '0.78rem', color: 'var(--muted)', marginTop: '0.2rem' }}>
                  🌐 Domain / Portfolio: {t.websiteUrl ? (
                    <a href={t.websiteUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--rose)', fontWeight: 700, textDecoration: 'underline' }}>
                      {t.domain}
                    </a>
                  ) : (
                    <strong>{t.domain}</strong>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tie-Up & Shared Office Information Banner */}
        <div className="card-glass" style={{ marginTop: '3rem', textAlign: 'center' }}>
          <span className="ey ey-r" style={{ marginBottom: '0.4rem' }}>Strategic Business Tie-Up & Office Location</span>
          <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.8rem', fontWeight: 700, color: 'var(--deep)', marginBottom: '0.6rem' }}>
            Sabitri Catering & Tent House 🤝 Vivah Nepal
          </h3>
          <p style={{ fontSize: '0.92rem', color: 'var(--mid)', maxWidth: '750px', margin: '0 auto 1.2rem', lineHeight: 1.7 }}>
            <strong>Sabitri Catering and Tent House</strong> (Owned by Krishna Khanal - 9867155395) and <strong>Vivah Nepal Matrimonial Agency</strong> (Owned by Laxmikant Timilsina - 9857074103) operate as close business partners out of our main office at <strong>Yogikuti Chowk, Butwal-10, Lumbini, Nepal</strong>.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
            <span className="tag" style={{ background: '#fff', fontSize: '0.82rem', padding: '0.4rem 1rem' }}>
              🌐 Vivah Nepal: <strong>vivahnepal.com</strong>
            </span>
            <span className="tag" style={{ background: '#fff', fontSize: '0.82rem', padding: '0.4rem 1rem' }}>
              🌐 Sabitri Catering: <strong>sabitricatering.com</strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
